import React, { Component } from 'react'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBTable, MDBTableBody, MDBTableHead, MDBIcon,MDBAlert,  MDBRow, MDBCol,} from 'mdbreact';
import Axios from 'axios'
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip, Descriptions   } from 'antd';
import { api, URL } from '../../api';
import Swal from 'sweetalert2/dist/sweetalert2.js'

import ReactExport from "react-export-excel";
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const date = new Date();
const [month, day, year]  = [String(date.getMonth() + 1).padStart(2, '0'), String(date.getDate()).padStart(2, '0'), date.getFullYear()];
const dates = year+"-"+month+"-"+day ;

var xlsx = require("xlsx");

export default class Modelresultsstudentshort extends Component {


    constructor(props) {
              super(props);
      this.state = {
        modal: false,
       
        Curriculumopen_Full_Name_TH:'',
        Curriculumopen_Full_Name_EN:'',
        Curriculumopen_CH:'',

        Curriculumopen_ID:'',
        Studentcb_ID:'',
        Citizen:'',
        Approve:'1',
        Approvegrade:'1',
        Curriculumopen_Approve_grade:'',
        Curriculumopen_faculty:'',
        studentlist:[],
        grade : [],
        currentDateTime: new Date().toISOString().slice(0, 10),
        Shortcoursemd_Status_grade:'',
        Shortcoursemd_Nameshort_TH:'',

        Shortcourse_typegrade:'',//สถานะส่งเกรด

       // Shortcourse_ID:'',
       // Shortcoursemd_ID:'',
        
      }

this.handleSubmit = this.handleSubmit.bind(this);
this.getregisterCurriculum = this.getregisterCurriculum.bind(this);
this.setgrade = this.setgrade.bind(this);
this.updategrade = this.updategrade.bind(this);
this.updategradeApprove = this.updategradeApprove.bind(this);
this.getregisterCurriculumupdate = this.getregisterCurriculumupdate.bind(this);
this.setgrade2 = this.setgrade2.bind(this);
this.readUploadFile = this.readUploadFile.bind(this);
}


            toggle = () => {
                this.setState({
                modal: !this.state.modal
                });
                this.setState({ Citizen:this.props.Citizen})
                this.setState({ Shortcourse_typegrade:this.props.Shortcourse_typegrade})
                this.getregisterCurriculum();
            }

            getregisterCurriculum() {
                setTimeout(() => {
                   //ภายใน
                   api.get('index/getregisterCurriculum/'+this.props.Curriculumopen_ID)
                   .then(res => {
                   //  console.log(res.data);
                     const Numlist = res.data.filter( ({ Studentcb_Citizen_ID }) => Studentcb_Citizen_ID === this.props.Citizen );
                   //  this.setState({ bankname: res.data, loading: false })
                     this.setState({ Numlist : Numlist})
                   }) 
                 }, 0);

            }


            getregisterCurriculumupdate() {
             //  this.setState({ Curriculumopen_ID:this.props.Curriculumopen_ID}) 
             //  this.setState({ Curriculumopen_Full_Name_TH:this.props.Curriculumopen_Full_Name_TH}) 
             // this.setState({ Curriculumopen_Approve_grade:this.props.Curriculumopen_Approve_grade})
             // this.setState({ Citizen:this.props.Citizen})
                setTimeout(() => {
                   api.get('index/getCurriculumstudentgradeshort/'+this.props.Shortcoursemd_ID+'/'+this.props.Shortcourse_ID,
                  //  Axios.get(`https://git.kpru.ac.th/FrontEnd_creditbank/index/getteacheruniv/`+localStorage.getItem('Univ_ID'),
                    //  Axios.get(`https://mis.kpru.ac.th/api/EmployeeInOrg/000`,
                            {headers: {
                            // Authorization: 'Bearer ' + localStorage.getItem('myData')
                            }
                            })
                            //  axios.defaults.headers.common['Authorization'] = `Bearer` + localStorage.getItem('myData') 
                            .then(res => {
                            //  console.log(res.data[0].id)
                            //  console.log(res.data)
                            //  const Course = res.data.filter( ({ Course_Year }) => Course_Year >= this.state.year );
                            //  console.log(Course)
                                const studentlist = res.data;
                                this.setState({ studentlist });
                             })        
                }, 2000);
             this.toggle();
           }



            updategradeApprove() {

              const datafrm2 = new FormData(); 
              datafrm2.append("Shortcourse_ID", this.state.Shortcourse_ID);
              datafrm2.append("Approvegrade", this.state.Approvegrade);
             // datafrm2.append("Curriculumopen_ID", this.state.Curriculumopen_ID);
            
              

            
                  api.post("index/updateApprovegradeshort/",datafrm2,{
                      headers: {
                          'content-type': 'multipart/form-data'
                      }
                    })

                  .then(res => {
                         if (res.status === 200) {
                         
                            
                                for (let index = 0; index < this.state.studentlist.length; index++) {

                                  const datafrm = new FormData(); 
                                //   datafrm.append("Studentcb_Citizen_ID", this.state.studentlist[index].Studentcb_Citizen_ID);
                                //   datafrm.append("Studentcb_Approve", this.state.Approve);
                                //   datafrm.append("Studentcb_Apsentby", localStorage.getItem('Citizen_ID'));
                                //   datafrm.append("Studentcb_ApproveDate", this.state.currentDateTime);
                                //   datafrm.append("Curriculumopen_ID", this.state.Curriculumopen_ID);

                                datafrm.append("Studentcbmd_Citizen_ID", this.state.studentlist[index].Studentcb_Citizen_ID);
                                datafrm.append("Shortcourse_ID", this.state.studentlist[index].Shortcourse_ID);
                                datafrm.append("Shortcoursemd_ID", this.state.studentlist[index].Shortcoursemd_ID);
                                datafrm.append("Studentcbmd_GRADE", this.state.studentlist[index].Studentcbmd_GRADE);
                                datafrm.append("Studentcbmd_Apsentby", localStorage.getItem('Citizen_ID'));
                                datafrm.append("Studentcbmd_Approve", this.state.Approve);
                                datafrm.append("Studentcbmd_ApproveDate", this.state.currentDateTime);

                                
                                      api.post("index/updategradesentApproveshort/",datafrm,{
                                          headers: {
                                              'content-type': 'multipart/form-data'
                                          }
                                        })

                                      .then(res => {
                                            if (res.status === 200) {
                                              //  alert("บันทึกสำเร็จ")
                                              if (this.state.studentlist.length === index+1) {
                                                 Swal.fire({
                                                            title: 'ส่งผลการเรียนสำเร็จ',
                                                            icon: 'success',
                                                          // showCancelButton: true,
                                                            confirmButtonText: 'ตกลง',
                                                          // cancelButtonText: 'No, keep it'
                                                          }).then((result) => {
                                                          this.getregisterCurriculumupdate();
                                                          })
                                              }
                                                       
                                            }
                                      })   
                              }

                          }
                  })   




           }



            updategrade() {

                     for (let index = 0; index < this.state.studentlist.length; index++) {

                                        // const totalp = this.state.Teacher.length;
                                        // const loops = index+1;
                                        // const percens = loops / totalp;
                                        // const percens2 = percens * 100;
                                        // this.setState ({ percenddd: percens2})

                                        // const st = this.state.Teacher[index].poname;
                                        // const nn = st.split(" ");
                                        // const naame =nn[0];
                                        // const lastnaame =nn[1];

                                const datafrm = new FormData(); 
                                datafrm.append("Studentcbmd_Citizen_ID", this.state.studentlist[index].Studentcb_Citizen_ID);
                                datafrm.append("Shortcourse_ID", this.state.studentlist[index].Shortcourse_ID);
                                datafrm.append("Shortcoursemd_ID", this.state.studentlist[index].Shortcoursemd_ID);
                                datafrm.append("Studentcbmd_GRADE", this.state.studentlist[index].Studentcbmd_GRADE);
                                datafrm.append("Studentcbmd_DATEADDGRADE", this.state.currentDateTime);
                                datafrm.append("Studentcbmd_score",  this.state.studentlist[index].Studentcbmd_score);
                                datafrm.append("Studentcbmd_GRADEFULL",  this.state.studentlist[index].Studentcbmd_GRADEFULL);
                              
                                    api.post("index/updategradestudentshort/",datafrm,{
                                        headers: {
                                            'content-type': 'multipart/form-data'
                                        }
                                      })

                                    .then(res => {
                                           if (res.status === 200) {
                                            //  alert("บันทึกสำเร็จ")
                                                      Swal.fire({
                                                          title: 'บันทึกผลการเรียนสำเร็จ',
                                                          icon: 'success',
                                                        // showCancelButton: true,
                                                          confirmButtonText: 'ตกลง',
                                                        // cancelButtonText: 'No, keep it'
                                                        }).then((result) => {
                                                            this.toggle();
                                                        })
                                           }
                                    })   
                    }
            }


            setgrade = index => evt => {
                console.log(evt.target.value)
                if (evt.target.value === "P" || evt.target.value === "PD" || evt.target.value === "F" || evt.target.value === "p" || evt.target.value === "pd" || evt.target.value === "F" || evt.target.value === "") {
                    const newShareholders = this.state.studentlist.map((studentlist, sidx) => {
                        if (index !== sidx) return studentlist;
                        return { ...studentlist, Studentcbmd_GRADE: evt.target.value };
                      });
                  
                      this.setState({ studentlist: newShareholders });
                }else{
                    Swal.fire({
                        title: 'ท่านกรอกผลการเรียนไม่ตรงตามเกณฑ์ที่กำหนด',
                        icon: 'warning',
                      // showCancelButton: true,
                        confirmButtonText: 'ตกลง',
                      // cancelButtonText: 'No, keep it'
                      }).then((result) => {
                      
                      })

                }
            }


             setgrade2 = index => evt => {
                console.log(evt.target.value)

                if (Number(evt.target.value) >= 0 && Number(evt.target.value) <= 100  ) {
                  
                       if (evt.target.value >=0 && evt.target.value <= 59) {

                                        // const newShareholders = this.state.studentlist.map((studentlist, sidx) => {
                                        //     if (index !== sidx) return studentlist;
                                        //     return { ...studentlist, Studentcbmd_GRADE: "F" ,Studentcbmd_score: evt.target.value };
                                        //   });
                                      
                                        //   this.setState({ studentlist: newShareholders });

                                         if (evt.target.value >=0 && evt.target.value <= 49) {

                                                       const newShareholders = this.state.studentlist.map((studentlist, sidx) => {
                                                          if (index !== sidx) return studentlist;
                                                          return { ...studentlist, Studentcbmd_GRADE: "F" ,Studentcbmd_score: evt.target.value , Studentcbmd_GRADEFULL: "E" };
                                                        });
                                                    
                                                        this.setState({ studentlist: newShareholders });
                        

                                    }else if (evt.target.value >=50 && evt.target.value <= 54) {
                                                
                                                      const newShareholders = this.state.studentlist.map((studentlist, sidx) => {
                                                          if (index !== sidx) return studentlist;
                                                          return { ...studentlist, Studentcbmd_GRADE: "F" ,Studentcbmd_score: evt.target.value , Studentcbmd_GRADEFULL: "D" };
                                                        });
                                                    
                                                        this.setState({ studentlist: newShareholders });

                                    }else if (evt.target.value >=55 && evt.target.value <= 59) {
                                                
                                                      const newShareholders = this.state.studentlist.map((studentlist, sidx) => {
                                                          if (index !== sidx) return studentlist;
                                                          return { ...studentlist, Studentcbmd_GRADE: "F" ,Studentcbmd_score: evt.target.value , Studentcbmd_GRADEFULL: "D+" };
                                                        });
                                                    
                                                        this.setState({ studentlist: newShareholders });


                                    }else if (evt.target.value >=60 && evt.target.value <= 64) {
                                                    const newShareholders = this.state.studentlist.map((studentlist, sidx) => {
                                                          if (index !== sidx) return studentlist;
                                                          return { ...studentlist, Studentcbmd_GRADE: "F" ,Studentcbmd_score: evt.target.value , Studentcbmd_GRADEFULL: "C" };
                                                        });
                                                    
                                                        this.setState({ studentlist: newShareholders });

                                    }else if (evt.target.value >=65 && evt.target.value <= 69) {
                                                  const newShareholders = this.state.studentlist.map((studentlist, sidx) => {
                                                          if (index !== sidx) return studentlist;
                                                          return { ...studentlist, Studentcbmd_GRADE: "F" ,Studentcbmd_score: evt.target.value , Studentcbmd_GRADEFULL: "C+" };
                                                        });
                                                    
                                                        this.setState({ studentlist: newShareholders });

                                    }else if (evt.target.value >=70 && evt.target.value <= 74) {
                                                     const newShareholders = this.state.studentlist.map((studentlist, sidx) => {
                                                          if (index !== sidx) return studentlist;
                                                          return { ...studentlist, Studentcbmd_GRADE: "F" ,Studentcbmd_score: evt.target.value , Studentcbmd_GRADEFULL: "B" };
                                                        });
                                                    
                                                        this.setState({ studentlist: newShareholders });

                                    }else if (evt.target.value >=75 && evt.target.value <= 79) {
                                                     const newShareholders = this.state.studentlist.map((studentlist, sidx) => {
                                                          if (index !== sidx) return studentlist;
                                                          return { ...studentlist, Studentcbmd_GRADE: "F" ,Studentcbmd_score: evt.target.value , Studentcbmd_GRADEFULL: "B+" };
                                                        });
                                                    
                                                        this.setState({ studentlist: newShareholders });
                                    }else if (evt.target.value >=80) {
                                                       const newShareholders = this.state.studentlist.map((studentlist, sidx) => {
                                                          if (index !== sidx) return studentlist;
                                                          return { ...studentlist, Studentcbmd_GRADE: "F" ,Studentcbmd_score: evt.target.value , Studentcbmd_GRADEFULL: "A" };
                                                        });
                                                    
                                                        this.setState({ studentlist: newShareholders });
                                    }

                       }else if (evt.target.value >=60 && evt.target.value <= 79) {
                                        //  const newShareholders = this.state.studentlist.map((studentlist, sidx) => {
                                        //     if (index !== sidx) return studentlist;
                                        //     return { ...studentlist, Studentcbmd_GRADE: "P" ,Studentcbmd_score: evt.target.value};
                                        //   });
                                      
                                        //   this.setState({ studentlist: newShareholders });


                                          if (evt.target.value >=0 && evt.target.value <= 49) {

                                                       const newShareholders = this.state.studentlist.map((studentlist, sidx) => {
                                                          if (index !== sidx) return studentlist;
                                                          return { ...studentlist, Studentcbmd_GRADE: "F" ,Studentcbmd_score: evt.target.value , Studentcbmd_GRADEFULL: "E" };
                                                        });
                                                    
                                                        this.setState({ studentlist: newShareholders });
                        

                                    }else if (evt.target.value >=50 && evt.target.value <= 54) {
                                                
                                                      const newShareholders = this.state.studentlist.map((studentlist, sidx) => {
                                                          if (index !== sidx) return studentlist;
                                                          return { ...studentlist, Studentcbmd_GRADE: "P" ,Studentcbmd_score: evt.target.value , Studentcbmd_GRADEFULL: "D" };
                                                        });
                                                    
                                                        this.setState({ studentlist: newShareholders });

                                    }else if (evt.target.value >=55 && evt.target.value <= 59) {
                                                
                                                      const newShareholders = this.state.studentlist.map((studentlist, sidx) => {
                                                          if (index !== sidx) return studentlist;
                                                          return { ...studentlist, Studentcbmd_GRADE: "P" ,Studentcbmd_score: evt.target.value , Studentcbmd_GRADEFULL: "D+" };
                                                        });
                                                    
                                                        this.setState({ studentlist: newShareholders });


                                    }else if (evt.target.value >=60 && evt.target.value <= 64) {
                                                    const newShareholders = this.state.studentlist.map((studentlist, sidx) => {
                                                          if (index !== sidx) return studentlist;
                                                          return { ...studentlist, Studentcbmd_GRADE: "P" ,Studentcbmd_score: evt.target.value , Studentcbmd_GRADEFULL: "C" };
                                                        });
                                                    
                                                        this.setState({ studentlist: newShareholders });

                                    }else if (evt.target.value >=65 && evt.target.value <= 69) {
                                                  const newShareholders = this.state.studentlist.map((studentlist, sidx) => {
                                                          if (index !== sidx) return studentlist;
                                                          return { ...studentlist, Studentcbmd_GRADE: "P" ,Studentcbmd_score: evt.target.value , Studentcbmd_GRADEFULL: "C+" };
                                                        });
                                                    
                                                        this.setState({ studentlist: newShareholders });

                                    }else if (evt.target.value >=70 && evt.target.value <= 74) {
                                                     const newShareholders = this.state.studentlist.map((studentlist, sidx) => {
                                                          if (index !== sidx) return studentlist;
                                                          return { ...studentlist, Studentcbmd_GRADE: "P" ,Studentcbmd_score: evt.target.value , Studentcbmd_GRADEFULL: "B" };
                                                        });
                                                    
                                                        this.setState({ studentlist: newShareholders });

                                    }else if (evt.target.value >=75 && evt.target.value <= 79) {
                                                     const newShareholders = this.state.studentlist.map((studentlist, sidx) => {
                                                          if (index !== sidx) return studentlist;
                                                          return { ...studentlist, Studentcbmd_GRADE: "P" ,Studentcbmd_score: evt.target.value , Studentcbmd_GRADEFULL: "B+" };
                                                        });
                                                    
                                                        this.setState({ studentlist: newShareholders });
                                    }else if (evt.target.value >=80) {
                                                       const newShareholders = this.state.studentlist.map((studentlist, sidx) => {
                                                          if (index !== sidx) return studentlist;
                                                          return { ...studentlist, Studentcbmd_GRADE: "P" ,Studentcbmd_score: evt.target.value , Studentcbmd_GRADEFULL: "A" };
                                                        });
                                                    
                                                        this.setState({ studentlist: newShareholders });
                                    }

                       }else if (evt.target.value >=80) {
                                      //  const newShareholders = this.state.studentlist.map((studentlist, sidx) => {
                                      //       if (index !== sidx) return studentlist;
                                      //       return { ...studentlist, Studentcbmd_GRADE: "PD" ,Studentcbmd_score: evt.target.value};
                                      //     });
                                      
                                      //     this.setState({ studentlist: newShareholders });


                                        if (evt.target.value >=0 && evt.target.value <= 49) {

                                                       const newShareholders = this.state.studentlist.map((studentlist, sidx) => {
                                                          if (index !== sidx) return studentlist;
                                                          return { ...studentlist, Studentcbmd_GRADE: "PD" ,Studentcbmd_score: evt.target.value , Studentcbmd_GRADEFULL: "E" };
                                                        });
                                                    
                                                        this.setState({ studentlist: newShareholders });
                        

                                    }else if (evt.target.value >=50 && evt.target.value <= 54) {
                                                
                                                      const newShareholders = this.state.studentlist.map((studentlist, sidx) => {
                                                          if (index !== sidx) return studentlist;
                                                          return { ...studentlist, Studentcbmd_GRADE: "PD" ,Studentcbmd_score: evt.target.value , Studentcbmd_GRADEFULL: "D" };
                                                        });
                                                    
                                                        this.setState({ studentlist: newShareholders });

                                    }else if (evt.target.value >=55 && evt.target.value <= 59) {
                                                
                                                      const newShareholders = this.state.studentlist.map((studentlist, sidx) => {
                                                          if (index !== sidx) return studentlist;
                                                          return { ...studentlist, Studentcbmd_GRADE: "PD" ,Studentcbmd_score: evt.target.value , Studentcbmd_GRADEFULL: "D+" };
                                                        });
                                                    
                                                        this.setState({ studentlist: newShareholders });


                                    }else if (evt.target.value >=60 && evt.target.value <= 64) {
                                                    const newShareholders = this.state.studentlist.map((studentlist, sidx) => {
                                                          if (index !== sidx) return studentlist;
                                                          return { ...studentlist, Studentcbmd_GRADE: "PD" ,Studentcbmd_score: evt.target.value , Studentcbmd_GRADEFULL: "C" };
                                                        });
                                                    
                                                        this.setState({ studentlist: newShareholders });

                                    }else if (evt.target.value >=65 && evt.target.value <= 69) {
                                                  const newShareholders = this.state.studentlist.map((studentlist, sidx) => {
                                                          if (index !== sidx) return studentlist;
                                                          return { ...studentlist, Studentcbmd_GRADE: "PD" ,Studentcbmd_score: evt.target.value , Studentcbmd_GRADEFULL: "C+" };
                                                        });
                                                    
                                                        this.setState({ studentlist: newShareholders });

                                    }else if (evt.target.value >=70 && evt.target.value <= 74) {
                                                     const newShareholders = this.state.studentlist.map((studentlist, sidx) => {
                                                          if (index !== sidx) return studentlist;
                                                          return { ...studentlist, Studentcbmd_GRADE: "PD" ,Studentcbmd_score: evt.target.value , Studentcbmd_GRADEFULL: "B" };
                                                        });
                                                    
                                                        this.setState({ studentlist: newShareholders });

                                    }else if (evt.target.value >=75 && evt.target.value <= 79) {
                                                     const newShareholders = this.state.studentlist.map((studentlist, sidx) => {
                                                          if (index !== sidx) return studentlist;
                                                          return { ...studentlist, Studentcbmd_GRADE: "PD" ,Studentcbmd_score: evt.target.value , Studentcbmd_GRADEFULL: "B+" };
                                                        });
                                                    
                                                        this.setState({ studentlist: newShareholders });
                                    }else if (evt.target.value >=80) {
                                                       const newShareholders = this.state.studentlist.map((studentlist, sidx) => {
                                                          if (index !== sidx) return studentlist;
                                                          return { ...studentlist, Studentcbmd_GRADE: "PD" ,Studentcbmd_score: evt.target.value , Studentcbmd_GRADEFULL: "A" };
                                                        });
                                                    
                                                        this.setState({ studentlist: newShareholders });
                                    }
                       }


                            








                }else{
                                  Swal.fire({
                                            title: 'ท่านกรอกผลการเรียนไม่ตรงตามเกณฑ์ที่กำหนด',
                                            icon: 'success',
                                          // showCancelButton: true,
                                            confirmButtonText: 'ตกลง',
                                          // cancelButtonText: 'No, keep it'
                                          }).then((result) => {
                                          
                                          })
                }

                
            }



            handleSubmit() {
                // alert('A name was submitted: ' + this.state.value);
               setTimeout(() => {           
                  const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
                  datafrm.append("Curriculumopen_ID", this.state.Curriculumopen_ID);
                  datafrm.append("Studentcb_ID", this.state.Studentcb_ID);
                  datafrm.append("Studentcb_Citizen_ID", this.state.Citizen);
                  
                  api.post("index/AddregisterCurriculum/",datafrm,{
                        headers: {
                            'content-type': 'multipart/form-data'
                        }
                   })
            
               .then(res => {
                //    console.log(res);
                    if (res.status === 200) {
                    //  alert("บันทึกสำเร็จ")
                              Swal.fire({
                                  title: 'ลงทะเบียนสำเร็จ',
                                  icon: 'success',
                                // showCancelButton: true,
                                  confirmButtonText: 'ตกลง',
                                // cancelButtonText: 'No, keep it'
                                }).then((result) => {
                                
                                })
                             }
                    })

                    this.getregisterCurriculum();
                   // this.toggle()
                  //  this.props.getclassroom()
            }, 1000);
            
            //window.location.href = '/Curriculum'
            //this.props.updateat();
            //this.getExpert()
             
              }




            componentDidMount() {

                //const { id_send } = this.props.id_send
                //console.log(this.props.Curriculumopen_ID);
                this.setState({ Curriculumopen_ID:this.props.Curriculumopen_ID}) 
                this.setState({ Curriculumopen_Full_Name_TH:this.props.Curriculumopen_Full_Name_TH}) 
                this.setState({ Curriculumopen_Approve_grade:this.props.Curriculumopen_Approve_grade})
                this.setState({ Curriculumopen_faculty:this.props.Curriculumopen_faculty})


                  this.setState({ Shortcoursemd_ID:this.props.Shortcoursemd_ID}) 
                  this.setState({ Shortcourse_ID:this.props.Shortcourse_ID}) 
                  this.setState({ Shortcoursemd_Status_grade:this.props.Shortcoursemd_Status_grade}) 
                  this.setState({ Shortcoursemd_Nameshort_TH:this.props.Shortcoursemd_Nameshort_TH}) 
    
               // this.setState({ Citizen:this.props.Citizen})
               
              
                api.get('index/getCurriculumstudentgradeshort/'+this.props.Shortcoursemd_ID+'/'+this.props.Shortcourse_ID,
                //  Axios.get(`https://git.kpru.ac.th/FrontEnd_creditbank/index/getteacheruniv/`+localStorage.getItem('Univ_ID'),
                  //  Axios.get(`https://mis.kpru.ac.th/api/EmployeeInOrg/000`,
                          {headers: {
                          // Authorization: 'Bearer ' + localStorage.getItem('myData')
                          }
                          })
                          //  axios.defaults.headers.common['Authorization'] = `Bearer` + localStorage.getItem('myData') 
                          .then(res => {
                          // console.log(res.data[0].id)
                          //  console.log(res.data)
                          //  const Course = res.data.filter( ({ Course_Year }) => Course_Year >= this.state.year );
                          //  console.log(Course)
                             const studentlist = res.data;
                              this.setState({ studentlist });
                   }) 
                //    this.getteacherforcurriculum();
                }


           
             readUploadFile = (e) => {
                               e.preventDefault();
                               if (e.target.files) {
                                   const reader = new FileReader();
                                   reader.onload = (e) => {
                                       const data = e.target.result;
                                       const workbook = xlsx.read(data, { type: "array" });
                                       const sheetName = workbook.SheetNames[0];
                                       const worksheet = workbook.Sheets[sheetName];
                                       const json = xlsx.utils.sheet_to_json(worksheet);
                                    //   console.log(json);
                                    const myArray = json.map((i) => ({
                                       Studentcb_Citizen_ID: i.เลขประจำตัวประชาชน,
                                       Studentcb_PNAME: i.คำนำหน้า,
                                       Studentcb_NAME: i.ชื่อ,
                                       Studentcb_SCOR: i.นามสกุล,
                                      
           
                                    }));
           
           
                                     this.setState({ datastuKamphaengphet: myArray })
                           
                                   };
                                   reader.readAsArrayBuffer(e.target.files[0]);
                               }
                           }


    render() {
        console.log(this.state.studentlist)
       


        return (
            <>
               
                    <MDBBtn onClick={this.toggle} color="primary" >จัดการผลการเรียน</MDBBtn>

                    <MDBModal isOpen={this.state.modal} toggle={this.toggle} size="lg">
                    <MDBModalHeader toggle={this.toggle}> <MDBIcon icon="tasks" /> กรอกผลการเรียน หลักสูตรระยะสั้น1 </MDBModalHeader>
                   
                        <MDBModalBody>
                            {/* {this.state.currentDateTime} */}

                            {this.state.Shortcourse_typegrade === '1'?<>
                                <p>เกณฑ์การให้เกรด</p>
                                <p>คะแนน 80-100 เกรด A </p>
                                <p>คะแนน 75-79 เกรด B+ </p>
                                <p>คะแนน 70-74 เกรด B </p>
                                <p>คะแนน 65-69 เกรด C+ </p>
                                <p>คะแนน 60-64 เกรด C </p>
                                <p>คะแนน 55-59 เกรด D+ </p>
                                <p>คะแนน 50-54 เกรด D </p>
                                <p>คะแนน 0-49 เกรด E </p>
                            </>:<>
                                <h5>หลักสูตร {this.props.Shortcoursemd_Nameshort_TH} </h5>  
                                <p>เกณฑ์การให้เกรด</p>
                                <p>คะแนน 0-59   เกรด F = ไม่ผ่าน <MDBIcon icon="check" /></p>
                                <p>คะแนน 60-79  เกรด P = ผ่าน <MDBIcon icon="check" /></p>
                                <p>คะแนน 80-100 เกรด PD = ผ่านยอดเยี่ยม <MDBIcon icon="times" /></p>
                            </>}
                           


{/* <MDBRow>
    <MDBCol size="5">

           <ExcelFile filename={this.state.Shortcoursemd_Nameshort_TH} element={<Button size="small">  &nbsp; <MDBIcon icon="file-excel" />&nbsp; ดาวน์โหลดรายชื่อ </Button>}>
               <ExcelSheet data={this.state.studentlist} name="รายชื่อผู้เรียน">
                                                                                           
                <ExcelColumn label="คำนำหน้า" style={{ rgb: "009900" }} value="FULLNAME" />
                <ExcelColumn label="ชื่อ" style={{ rgb: "009900" }} value="Studentcb_NAME" />
                <ExcelColumn label="นามสกุล" value="Studentcb_LASTNAME" />
                <ExcelColumn label="เบอร์โทร" value="Studentcb_TEL" />
                <ExcelColumn label="อีเมลล์" value="Studentcb_EMAIL" />
                                                                                             
               </ExcelSheet>
           </ExcelFile>
    </MDBCol>
    <MDBCol size="5">

                <label htmlFor="upload">Upload File ผลการเรียน</label><br/>
                       <input
                          type="file"
                          name="upload"
                          id="upload"
                          onChange={this.readUploadFile}
                        />              

    </MDBCol>
</MDBRow> */}

                                  
                                    <br/>

                             <MDBTable bordered small>
                                <MDBTableHead  color="grey darken-1" textWhite>
                                    <tr>
                                    <th>ลำดับ</th>
                                    <th>ชื่อ</th>
                                    <th>นามสกุล</th>
                                    <th>คะแนน</th>
                                     {this.state.Shortcourse_typegrade === '1'?<>
                                        <th>ผลการเรียนปกติ A-E</th>
                                    </>:<>
                                       <th>ผลการเรียน PD/P/F</th>
                                    </>}
                                    <th>เกียรติบัตร/วุฒิบัตร</th>
                                    </tr>
                                </MDBTableHead>
                                <MDBTableBody>
                                    {this.state.studentlist.map((studentlist,index) =>{ 
                                       
                                       const cid = "https://e-student.kpru.ac.th/creditbank/creditbankpdf/TCPDF-main/certificatecreditbankshort.php?idci="+studentlist.Studentcb_Citizen_ID+"&idculi="+studentlist.Shortcourse_ID+"&idshortmd="+studentlist.Shortcoursemd_ID;
                                       const cid2 = "https://e-student.kpru.ac.th/creditbank/creditbankpdf/TCPDF-main/certificate/"+studentlist.Studentcb_Code_Certificate+".pdf";
                                    return  <tr>
                                                <td>{index+1}</td>
                                                <td>{studentlist.FULLNAME}{studentlist.Studentcb_NAME}</td>
                                                <td>{studentlist.Studentcb_LASTNAME}</td>
                                                {/* <td>
                                                    <div key={index} className="input-group">
                                                        <input type="text"
                                                       
                                                            className="form-control"
                                                            onChange={this.setgrade2(index)} value={studentlist.Studentcb_score} />
                                                    </div>
                                                </td> */}
                                                      <td>
                                                    {/* <div key={index} className="input-group">
                                                        <input type="text"
                                                       
                                                            className="form-control"
                                                            onChange={this.setgrade2(index)} value={studentlist.Studentcb_GRADE} />  = {studentlist.Studentcb_GRADE}
                                                    </div> */}
                                                     <div key={index} className="input-group">
                                                     { this.state.Curriculumopen_Approve_grade === '1'?<>
                                                     <input type="text" 
                                                       
                                                            className="form-control"
                                                            onChange={this.setgrade2(index)} value={studentlist.Studentcbmd_score} disabled /> 
                                                     </>:<>
                                                     <input type="text" 
                                                       
                                                            className="form-control"
                                                            onChange={this.setgrade2(index)} value={studentlist.Studentcbmd_score}  /> 
                                                     </>}
                                                         
                                                    </div>
                                                    
                                                </td>
                                                 {this.state.Shortcourse_typegrade === '1'?<>
                                                 <td className='text-center'>{studentlist.Studentcbmd_GRADEFULL}</td>
                                                 </>:<>
                                                 <td className='text-center'>{studentlist.Studentcbmd_GRADE}</td>
                                                 </>}
                                                 
                                                <td>
                                                  {studentlist.Studentcbmd_Approve ==="1" ?<>

                                                    {studentlist.Studentcbmd_Code_Certificate != null ?<> {
                                                              <MDBBtn
                                                                href={cid2}
                                                                target="_blank"
                                                                color="unique"
                                                                 >พิมพ์แล้ว</MDBBtn>
                                                                  }</>:<>
                                                     {
                                                              <MDBBtn
                                                                href={cid}
                                                                target="_blank"
                                                                color="secondary"
                                                                onClick={this.getregisterCurriculumupdate}
                                                                 >DOWNLOAD</MDBBtn>
                                                                  }
                                                    </>}
                                                            


                                                  </>:<>อยู่ระหว่างดำเนินการ</>}
                                                  </td>
                                               
                                            </tr>
                                    } )}
                                   
                                    
                                </MDBTableBody>
                             </MDBTable>
                             {this.state.Shortcoursemd_Status_grade === '1' ? <> <p className="purple-text text-center">กดส่งผลการเรียนแล้ว</p>  </>:<>
                             <p className="text-center"><MDBBtn color="info"  onClick={this.updategrade}>บันทึกผลการเรียน</MDBBtn> <MDBBtn color="mdb-color"  onClick={this.updategradeApprove}>ส่งผลการเรียน</MDBBtn></p> 
                             </>}
                             
                            {/* {this.state.Curriculumopen_Approve_grade === '2' ?<> 
                            <MDBAlert color="success" className="text-center" >
                               <h3><MDBIcon icon="check" />  คณบดีอนุมัติแล้ว</h3>  
                             </MDBAlert>
                             </> :<> 
                             <p className="text-center"><MDBBtn color="info"  onClick={this.updategrade}>บันทึกผลการเรียน</MDBBtn> <MDBBtn color="mdb-color"  onClick={this.updategradeApprove}>ส่งผลการเรียน</MDBBtn></p> 
                             </>} */}
                           
                            <p className="text-center"></p> 
                             
                        </MDBModalBody>
                        <MDBModalFooter>
                        <MDBBtn color="secondary" onClick={this.toggle}>ปิด</MDBBtn>
                        {/* <MDBBtn color="primary">Save changes</MDBBtn> */}
                        </MDBModalFooter>
                    </MDBModal>
               
            </>
        )
    }
}
